<template>
  <div id="magic-zoom">
    <template v-if="reducedSpecial !='none'">
      <template v-if="reducedSpecial == 'special'">
        <div class="phywe-aktion-wrapper">
          <div class="phywe-aktion">
            {{ magiczoom.item.storeSpecial.names.name }}
          </div>
        </div>
      </template>
      <template v-if="reducedSpecial == 'reduced'">
        <div class="reduced">
          <span>%</span>
        </div>
      </template>
    </template>
    <div itemscope itemtype="http://schema.org/Thing">
      <div class="ItemImgWrap justify-content-center mt-3 mt-md-0" :class="{'more-images': magiczoom.images.all.length > 0 }">
        <!-- TODO: Magiczoom multiligual -->
        <a :href="magiczoom.images | itemImages('url') | itemImage" id="ItemImgZoom" class="MagicZoomPlus flex-fill d-flex align-items-start justify-content-center"
           :data-mobile-options="'zoomMode:off; lazyZoom: true; textTouchZoomHint:'+  $translate('Phywe::Template.singleZoomHint') +'; textClickZoomHint: '+ $translate('Phywe::Template.singleZoomHint2') +'; textExpandHint: '+$translate('Phywe::Template.singleZoomHint')"
           :data-options="'lazyZoom: true;cssClass: white-bg; zoom-height:500px; textHoverZoomHint:'+$translate('Phywe::Template.singleZoomHint3')+'; textExpandHint:'+ $translate('Phywe::Template.singleZoomHint3')+'; zoomPosition: #zoom-placeholder;'">
          <img  class="img-fluid" :src="magiczoom.images | itemImages('url') | itemImage" itemprop="image">
        </a>
        <template v-if="magiczoom.images.all.length > 0">
          <div class="magic-more-images d-none d-lg-block" v-if="magiczoom.images.all.length >= 4">
            <div @click="slidePrev" class="hooper-icons up" v-if="magiczoom.images.all.length > 4">
              <i class="fa fa-chevron-up" aria-hidden="true"></i>
            </div>
            <hooper class="d-none d-lg-block" :vertical="true" :infiniteScroll="false" :itemsToShow="4" :trimWhiteSpace="true" ref="carousel">
              <slide v-if="hasVideo">
                <a class="border video d-flex mb-2 videoImage cursor"  @click="showVideo()">
                  <i class="fa fa-play-circle-o" v-if="!loading"></i>
                  <i class="fa fa-circle-o-notch fa-spin" v-else></i>
                </a>
              </slide>
              <slide v-for="(imagePreview, index) in magiczoom.images.all" :key="index">
                <a :href="magiczoom.images.all[index].url" rel="zoom-id:ItemImgZoom" :data-image="magiczoom.images.all[index].url" class="border">
                  <img
                      :data-src="imagePreview.url"
                      :src="imagePreview.urlPreview">
                </a>
              </slide>
            </hooper>
            <div @click="slideNext" class="hooper-icons down" v-if="magiczoom.images.all.length > 4">
              <i class="fa fa-chevron-down" aria-hidden="true"></i>
            </div>
          </div>
          <div class="magic-more-images d-none d-lg-block" v-else>
            <template v-if="hasVideo">
              <a class="border video d-flex mb-2 videoImage"  @click="showVideo()">
                <i class="fa fa-play-circle-o" v-if="!loading"></i>
                <i class="fa fa-circle-o-notch fa-spin" v-else></i>
              </a>
            </template>
            <template v-for="(imagePreview, index) in magiczoom.images.all">
              <a :href="magiczoom.images.all[index].url" rel="zoom-id:ItemImgZoom" :data-image="magiczoom.images.all[index].url" class="mb-2 border">
                <img
                    :data-src="imagePreview.url"
                    :src="imagePreview.urlPreview">
              </a>
            </template>
          </div>
        </template>
      </div>
      <div class="zoom-navigation-dots d-md-none">
      </div>
    </div>
    <div id="video-modal-wrapper" v-if="hasVideo">
      <div class="modal fade" id="video-modal" tabindex="-1" role="dialog" @hidden.bs.modal="stopVideo">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <div class="modal-title h4">Video</div>
              <button type="button" class="close" data-dismiss="modal" @click="closeVideo()">&times;</button>
            </div>
            <div class="modal-body">

              <div class="video-container" v-if="showvid">
                <template v-if="videoList.length > 0">
                  <iframe
                      v-for="(url, idx) in videoList"
                      :key="idx"
                      class="mb-4"
                      width="100%"
                      height="315"
                      :src="normalizedVideoUrl(url)"
                      title="Video"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen>
                  </iframe>
                </template>
                <template v-else>
                  <iframe
                      width="100%"
                      height="315"
                      :src="'https://www.youtube-nocookie.com/embed/'+video"
                      title="Video"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen>
                  </iframe>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide  } from 'hooper';
export default
{
  components: { Hooper, Slide },
  props:
      {
        template:
            {
              type: String,
              default: "#vue-magic-zoom"
            },
        videoUrls:
            {
              type: [Array, String],
              default: () => []
            }
      },
  inject:
      {
        itemId:
            {
              default: null
            }
      },
  data: function()
  {
    return {
      showvid:false,
      loading:false,
      onloadVarId : this.currentVariation().variation.id,
      dotsCount   : 0
    }
  },
  methods:
      {
        closeVideo:function()
        {
          this.stopVideo();
          $('#video-modal').modal('hide');
        },
        showVideo:function()
        {
          this.showvid = true;
          $('#video-modal').modal('show');
        },
        stopVideo:function()
        {
          this.showvid = false;
        },
        normalizedVideoUrl:function(url)
        {
          if(!url) { return ''; }
          let cleaned = String(url).trim();
          // remove escaped slashes and surrounding quotes/brackets if present
          cleaned = cleaned.replace(/\\\//g, '/');
          cleaned = cleaned.replace(/^[\[\"]+|[\]\"]+$/g, '');
          cleaned = cleaned.replace(/^\'|\'$/g, '');
          cleaned = cleaned.replace(/^http:/, 'https:');
          return cleaned;
        },
        currentVariation: function()
        {
          return this.$store.getters[`${this.itemId}/currentItemVariation`];
        },
        getDots: function()
        {
          this.dotsCount =   this.currentVariation().images.all.length
        },
        slideNext() {
          this.$refs.carousel.slideNext();
        },
        slidePrev() {
          this.$refs.carousel.slidePrev();
        }
      },
  computed:
  {
    video: function ()
    {
      let props = this.currentVariation();
      if(props.hasOwnProperty('variationProperties'))
      {
        let eigenschaften = props.variationProperties;
        let video = '';
        for (let i = 0; i < eigenschaften.length; i++) {
          if (eigenschaften[i].id == 2) {
            for (let t = 0; t < eigenschaften[i].properties.length; t++)
            {
              if (eigenschaften[i].properties[t].id == 175) {
                video = eigenschaften[i].properties[t].values.value;
              }
            }
          }
        }
       return video;
      }
      else
      {
        return '';
      }
    },
    magiczoom: function()
    {
      this.getDots();
      return this.currentVariation();
    },
    reducedSpecial:function()
    {
      let current = this.currentVariation()
      if(current.item.storeSpecial != null && current.prices.rrp != null)
      {
        if(current.prices.rrp.price.value > current.prices.default.price.value)
        {
          return 'reduced'
        }
        else
        {
          return 'special'
        }
      }
      if(current.item.storeSpecial != null)
      {
        return 'special'
      }
      if(current.prices.rrp != null)
      {
        if(current.prices.rrp.price.value > current.prices.default.price.value)
        {
          return 'reduced'
        }
      }
      return 'none'
    },
    hasVideo:function()
    {
      return this.videoList.length > 0 || this.video !== '';
    },
    videoList:function()
    {
      let list = [];
      if (Array.isArray(this.videoUrls))
      {
        list = this.videoUrls;
      }
      else if (typeof this.videoUrls === 'string')
      {
        const trimmed = this.videoUrls.trim();
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed))
          {
            list = parsed;
          }
          else if (typeof parsed === 'string' && parsed.length)
          {
            list = [parsed];
          }
        } catch (e) {
          list = trimmed.split(',').map(entry => entry.trim());
        }
      }
      return list
          .map(entry => this.normalizedVideoUrl(entry))
          .filter(entry => entry && entry.length > 0);
    }
  },
  mounted()
  {
    $('#video-modal').on('hidden.bs.modal', this.stopVideo);
  },
  beforeDestroy()
  {
    $('#video-modal').off('hidden.bs.modal', this.stopVideo);
  }
}
</script>
